
import New from '../New';
import { EyeIcon } from '@heroicons/react/24/solid'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Toast from 'react-bootstrap/Toast';



const Quiz = ({ topic }) => {



    const { question, options, correctAnswer } = topic;


    const quizCheck = (selectedAnswer) => {


        if (selectedAnswer === correctAnswer) {



            toast.success("Conratulation Your Ans is Currect", {
                position: toast.POSITION.TOP_CENTER
            });
        } else {
            toast.error("Oh! Your Ans wan't Currect", {
                position: toast.POSITION.TOP_CENTER
            });

        }

    }


    const [show, setShow] = useState(false);

    return (
        <section>


            <div className='container flex flex-col justify-center px-4 py-2 mx-auto md:px-8  border-solid border-2 border-indigo-600 mt-5'>

              
            <div className='flex items-center justify-between' >
                    <label className='text-cyan-800 py-5 p-5 text-2xl font-bold' > Quetion : {question.slice(3, -4)} </label><br />
                    <EyeIcon onClick={() => setShow(true)} className="h-6 w-6 text-blue-500  cursor-pointer " />
                </div>
                    <div className='flex justify-end'>
                        <Row>
                            <Col xs={6}>
                                <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
                                    <Toast.Header>
                                        <img
                                            src="holder.js/20x20?text=%20"
                                            className="rounded me-2"
                                            alt=""
                                        />
                                        <strong className="me-auto">Carrect Answer :</strong>

                                    </Toast.Header>
                                    <Toast.Body className=' text-emerald-600 font-bold'>{correctAnswer}</Toast.Body>
                                </Toast>
                            </Col>
                            <Col xs={6}>

                            </Col>
                        </Row>
                    </div>
                
                





                {
                    options.map(newop => <New quizCheck={quizCheck}  newop={newop}></New>)

                }

                < ToastContainer />

            </div>

        </section>

    );
};

export default Quiz;
